import React from "react";
import styled from "styled-components";

const StyledMessageWrapper = styled.div`
  width: 100%;
  height: 100px;
  border: 1px solid #c2c2c2;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 400;
  border-radius: 4px;
  color: #939fa5;
`;

export default function NoCardFound() {
  return (
    <StyledMessageWrapper>
      Nothing Found For This Selection
    </StyledMessageWrapper>
  );
}
